import { BuildUri } from "./BuildUri";

import { WorkRegion } from "../model/WorkRegion";
import { RegionRequest } from "../requests/RegionRequest";

import context from "../context";

class RegionEndpoints {

    getRegionList(): Promise<Array<WorkRegion>> {
        return context.fetch(
            BuildUri("/region")
        );
    }

    createRegion(obj: RegionRequest): Promise<WorkRegion> {
        return context.fetch(
            BuildUri("/region"),
            {
                method: "POST",
                body: obj
            }
        );
    }

    editRegion(regionId: number, obj: RegionRequest): Promise<WorkRegion> {
        return context.fetch(
            BuildUri("/region/{regionId}", {regionId}),
            {
                method: "PUT",
                body: obj
            }
        );
    }

    deleteRegion(regionId: number): Promise<WorkRegion> {
        return context.fetch(
            BuildUri("/region/{regionId}", {regionId}),
            {
                method: "DELETE"
            }
        );
    }

}

export default new RegionEndpoints();
